import { styled } from "@mui/material";
import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import Button from "../../../../customs/Button";
import Input from "../../../../customs/FormInput";
import Select from "../../../../customs/SelectInput";

const EditRoleContent = () => {
    const formik = useFormik<FormikValues>({
        initialValues: {

        },
        onSubmit: () => {

        }
    })

    return (
        <FormikProvider value={formik}>
            <form>
                <FormWrapper>
                    <Field 
                        name='name'
                        type='text'
                        as={Input}
                        label='Name'
                        placeholder='Name'
                    />
                    <Field 
                        name='status'
                        type='text'
                        as={Select}
                        label='Status'
                    />
                </FormWrapper>
                <ButtonWrapper>
                    <ButtonContainer>
                        <StyledButton text='Cancel'/>
                        <StyledButton type="submit" text='Edit'/>
                    </ButtonContainer>
                </ButtonWrapper>
            </form>
        </FormikProvider>
    )
};

export default EditRoleContent;

const FormWrapper = styled('div')`
    margin-inline: 3.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
    padding-inline: 3.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
`

